import React from 'react';
import { Form, DatePicker } from 'antd';

/**
 * Reusable Date Picker Field Component
 * For date inputs with validation
 * 
 * @param {string} name - Field name
 * @param {string} label - Field label
 * @param {string} placeholder - Placeholder text
 * @param {boolean} required - Whether field is required
 * @param {boolean} readOnly - Whether field is read-only
 * @param {string} format - Date format (default: 'YYYY-MM-DD')
 * @param {string} picker - Picker type (date, week, month, quarter, year)
 * @param {boolean} showTime - Whether to show time picker
 * @param {Array} rules - Additional validation rules
 * @param {object} ...props - Additional props passed to DatePicker
 */
const DateField = ({ 
  name, 
  label, 
  placeholder, 
  required = false, 
  readOnly = false,
  format = 'YYYY-MM-DD',
  picker = 'date',
  showTime = false,
  rules = [],
  ...props 
}) => (
  <Form.Item
    name={name}
    label={label}
    rules={required ? [{ required: true, message: `Please select ${label.toLowerCase()}` }, ...rules] : rules}
  >
    <DatePicker 
      placeholder={placeholder}
      size="large"
      className="w-full rounded-lg"
      format={format}
      picker={picker}
      showTime={showTime}
      disabled={readOnly}
      style={readOnly ? { cursor: 'not-allowed', backgroundColor: '#f9fafb' } : { backgroundColor: '#f9fafb' }}
      {...props}
    />
  </Form.Item>
);

export default DateField;
